import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import fetchProject from 'api/project/fetchProject';
import API_END_POINT from 'constants/apiEndPoints';

type UpdateProjectValues = {
  [index: string]: any;
};

const createProjectQueryKey = ({ ownerName, projectName }: { ownerName: string; projectName: string }) => {
  return [API_END_POINT.PROJECT.FETCH_PROJECTS, ownerName, projectName];
};

const useProject = (options?: { refetchOnMount?: boolean | 'always'; enabled?: boolean }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { ownerName, projectName } = useParams();

  const projectQueryData = useQuery({
    queryKey: createProjectQueryKey({ ownerName: ownerName!, projectName: projectName! }),
    queryFn: () => fetchProject({ ownerName: ownerName!, projectName: projectName! }),
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });

  const update = (values: UpdateProjectValues) => {
    if (!projectQueryData.data) return;

    const oldOwnerName = projectQueryData.data.ownerName;
    const oldProjectName = projectQueryData.data.projectName;
    const ownerName = values['ownerName'] ?? oldOwnerName;
    const projectName = values['projectName'] ?? oldProjectName;

    queryClient.setQueryData(createProjectQueryKey({ ownerName, projectName }), {
      ...projectQueryData.data,
      ...values,
    });

    // 프로젝트 정보가 바뀐 경우 이전 프로젝트 캐시 삭제
    if (oldOwnerName !== ownerName || oldProjectName !== projectName) {
      navigate(`/${ownerName}/${projectName}`);
      // queryClient.removeQueries({
      //   queryKey: createProjectQueryKey({ ownerName: oldOwnerName, projectName: oldProjectName }),
      // });
    }
  };

  return {
    ...projectQueryData,
    update,
    ownerName,
    projectName,
  };
};

export default useProject;
